import React from 'react';
import PropTypes from 'prop-types';

function IconMoveBottom({ color = '#B3B3B3', size = 16, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7267_15516)">
        <path d="M6 8.5L8 10.5M8 10.5L10 8.5M8 10.5V5.5M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_7267_15516">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

IconMoveBottom.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
}

export default IconMoveBottom;
